import PartnershipUsersTable from './PartnershipUsersTable';

export default PartnershipUsersTable;
